
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import wx from 'weixin-js-sdk';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'

import Datetime from 'vux/src/components/datetime/index.vue'


export default {
components: {
cmBlank,cmLoadmore,Popup,Group,PopupHeader,XButton,Radio,Datetime, wx
},
directives: {
TransferDom
},
data () {
return {
blankShow:false,
loadStatus:false,
loadmoreText:'正在加载。。。',
busy:false,
code:'',
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
isActive:2,
statusArr:[
{
key:2,
num:0,
value:'已支付',
},
{
key:1,
num:0,
value:'未支付',
},
],
}
},
created(){

this.config();


},
amount(){
this.code = '';
},
methods:{
copy(val){
this.$func.copy(val,event);
},
searchOrder(orderNo){
this.$router.push({name:'searchOrder',params:{code:orderNo}})
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
},
resetSearch(){
this.code = '';
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
},
selectStatus(val){
if(this.isActive === val){
return false;
}
this.isActive = val;
this.search();
},
queryExpress(code){
this.$router.push({name:'queryExpress',params:{code:code}})
},
getList(){
this.$api.getWaybillWashOrderList({last_id:this.lastId,page_flag:this.pageFlag,code:this.code,status:this.isActive}).then((res)=>{
if(res){
let list = res.data.filter(item => Number(item.status) !== 10);
if(!this.lastId){
this.blankShow = list.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
list.forEach((item)=>{
this.list.push(item);
});
}
})
},
pay(id){
if(!id){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
this.$func.confirm('确认支付？','提示',()=>{
if (typeof WeixinJSBridge == "undefined"){
const onBridgeReady = () => {
this.onBridgeReady(id);
};
if(document.addEventListener){
document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
}else if(document.attachEvent){
document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
}
}else{
this.onBridgeReady(id);
}
})
},
onBridgeReady(id){
let that = this;
this.$api.payWaybillWashOrder({id:id}).then((res)=>{
if(res){
WeixinJSBridge.invoke(
'getBrandWCPayRequest', res.data,
function(res){
if(res.err_msg == "get_brand_wcpay_request:ok" ){
that.$func.showToast('支付成功');
setTimeout(()=>{
that.search();
},300);
}else{
that.$func.showToast('已取消支付');
}
}
);
}
})
},
changeStatus(id,status,isCancel){
if(!id){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
this.$func.confirm(isCancel ? '确认取消订单？' : '确认申请退款？','提示',()=>{
this.$api.changeOrderParentStatus({id:id,status:status,type:5}).then((res)=>{
if(res){
setTimeout(()=>{
this.pickerStatus = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;

this.loadmore();
}, 300);
}
});
})
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{

that.code = that.$func.parseScanResult(res.resultStr);
let prefix = that.code.substring(0,4);
if(prefix == 'JDVG'){
that.code = that.code.substring(0,15);
}
that.search();
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';
this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/waybillWashOrder.vue